import { useEffect, useState } from 'react';

const TERSER_ESM_URL = 'https://cdn.jsdelivr.net/npm/terser@5.27.0/+esm';

type MinifyFn = (code: string, options?: Record<string, unknown>) => Promise<{ code?: string; error?: Error }>;

let cached: Promise<MinifyFn> | null = null;

const loadTerser = (): Promise<MinifyFn> => {
	if (cached) return cached;
	// Bypass webpack's import() rewriting so the URL is fetched at runtime as a
	// native ES module. jsdelivr's `+esm` endpoint converts terser (CJS) into
	// browser-loadable ESM with named exports.
	const dynamicImport = new Function('url', 'return import(url)') as (url: string) => Promise<{ minify: MinifyFn }>;
	cached = dynamicImport(TERSER_ESM_URL).then((mod) => mod.minify);
	return cached;
};

export const useTerser = (): { minify: MinifyFn | null; error: Error | null } => {
	const [minify, setMinify] = useState<MinifyFn | null>(null);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		let cancelled = false;
		loadTerser()
			.then((fn) => {
				if (!cancelled) setMinify(() => fn);
			})
			.catch((e) => {
				if (!cancelled) setError(e instanceof Error ? e : new Error(String(e)));
			});
		return () => {
			cancelled = true;
		};
	}, []);

	return { minify, error };
};
